import { render, staticRenderFns } from "./IntegrationFormAdditionalData.vue?vue&type=template&id=58544add&scoped=true&"
import script from "./IntegrationFormAdditionalData.vue?vue&type=script&lang=ts&"
export * from "./IntegrationFormAdditionalData.vue?vue&type=script&lang=ts&"
import style0 from "./IntegrationFormAdditionalData.vue?vue&type=style&index=0&id=58544add&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58544add",
  null
  
)

export default component.exports